import { render, staticRenderFns } from "./calculadoraEmprestimo.vue?vue&type=template&id=67ce765d"
import script from "./calculadoraEmprestimo.vue?vue&type=script&lang=js"
export * from "./calculadoraEmprestimo.vue?vue&type=script&lang=js"
import style0 from "./calculadoraEmprestimo.vue?vue&type=style&index=0&id=67ce765d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports